import type { GetServerSidePropsContext } from 'next';
import Recall from '@elem/compPage/efdelta-recall-reception';
import css from '@elem/compPage/efdelta-recall-reception/page.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';

const whiteLocaleList = ['jp'];

export default function Page({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const router = useRouter();
    const { t } = useLang('recall');

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={router.locale} list={whiteLocaleList} pathname={'efdelta-recall-reception'} />
            <PageLayout className={`${css.recall}`}>
                <Recall />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
